import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";

const url = process.env.REACT_APP_API_URL + "/vehicles";

function Vehicles() {
  const navigate = useNavigate();
  const [vehicles, setVehicles] = useState([]);

  /**
   * @desc Get vehicle data
   */
  const getVehicles = async () => {
    try {
      const response = await axios.get(url);
      setVehicles(response.data.vehicles);
    } catch (err) {
      console.log("Error while getting vehicle list...");
    }
  };

  useEffect(() => {
    getVehicles();
  }, []);

  /**
   * @desc Delete a vehicle
   * @param {*} id
   */
  const deleteVehicle = async (vehicleId) => {
    try {
      if (JSON.parse(localStorage.getItem("fixit_user"))) {
        await axios.delete(`${url}/${vehicleId}`, {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("fixit_user")).token,
          },
        });
      }

      getVehicles();
    } catch (err) {}
  };

  /**
   * @desc Edit a vehicle
   * @param {*} id
   */
  const editVehicle = async (vehicle) => {
    navigate("/edit-vehicle", {
      state: vehicle,
    });
  };

  return (
    <div
      style={{
        marginTop: "7rem",
        color: "black",
        marginBottom: "3.5rem",
      }}
      className="container"
    >
      <table className="table table-dark table-striped">
        <thead>
          <tr>
            <th scope="col">Vehicle</th>
            <th scope="col">Type</th>
            <th scope="col">Services</th>
            <th scope="col" style={{ width: "3.5rem" }}>
              Edit/Delete
            </th>
          </tr>
        </thead>
        <tbody>
          {vehicles.map((vehicle) => {
            return (
              <tr key={vehicle._id}>
                <td>
                  <p>
                    {vehicle.manufacturer} {vehicle.name}
                  </p>
                </td>
                <td>
                  <p>
                    {vehicle.type}{" "}
                    <span className="text-muted">({vehicle.cc}CC)</span>
                  </p>
                </td>
                <td>
                  <ul className="list-group">
                    {vehicle.services.map((service) => {
                      return (
                        <li
                          className="list-group-item list-group-item-dark"
                          key={service._id}
                        >
                          {service.name}
                        </li>
                      );
                    })}
                  </ul>
                </td>
                <td>
                  <div
                    className="btn-group"
                    role="group"
                    aria-label="Basic example"
                  >
                    <button
                      onClick={() => editVehicle(vehicle)}
                      type="button"
                      className="btn btn-warning"
                    >
                      <i className="bi bi-pencil-fill"></i>
                    </button>
                    <button
                      onClick={() => deleteVehicle(vehicle._id)}
                      type="button"
                      className="btn btn-danger"
                    >
                      <i className="bi bi-trash-fill"></i>
                    </button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default Vehicles;
